import { memo, useContext, useEffect } from "react";
import { Data } from "./App";
import Address from "./Address";
import InputText from "./InputText";
import styles from "./App.module.scss";
import { useState } from "react";

const User = memo(() => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);
	const [own, setOwn] = useState(false);
	useEffect(() => {
		setTimeout(() => {
			setErrors({
				...errors,
				uname: inputs.uname === null ? "*必須" : null,
				ufurigana: inputs.ufurigana === null ? "*必須" : null,
				postcode: inputs.postcode === null ? "*必須" : null,
				address: inputs.address === null ? "*必須" : null,
				tel: inputs.address === null ? "*必須" : null,
			});
		}, 10);
		return () => {
			setErrors({
				...errors,
				uname: null,
				ufurigana: null,
				postcode: null,
				address: null,
				tel: null,
			});
		};
	}, []);

	const userOwn = () => {
		if (own) {
			setOwn(false);
			setInputs({ ...inputs, uname: null, ufurigana: null });
			setErrors({ ...errors, uname: "*必須", ufurigana: "*必須" });
		} else {
			setOwn(true);
			setInputs({ ...inputs, uname: "同上", ufurigana: "同上" });
			setErrors({ ...errors, uname: null, ufurigana: null });
		}
	};

	return (
		<>
			<div className={styles.formMain}>
				<h3 className={`en ${styles.headline}`}>
					PURCHASE<span>ご購入時の情報をご入力</span>
				</h3>
				<div>
					<div className={styles.addCheckBoxInput}>
						<div>
							<InputText
								label={"ご購入名義"}
								name={"uname"}
								placeholder={"ノイエス太郎"}
								max={20}
								require
							/>
							<InputText
								label={"ふりがな"}
								name={"ufurigana"}
								placeholder={"のいえすたろう"}
								max={20}
								require
							/>
						</div>
						<label>
							<input type="checkbox" onChange={userOwn} checked={own} />
							同上
						</label>
					</div>
					<Address />
				</div>
			</div>
		</>
	);
});

export default User;
